import BasicText from "@/components/BasicText";
import Title from "@/components/Title";
import WhyNodeComponent from "./WhyNodeComponent";
import starShape from "@/assets/images/why-node-star.png";
import globeShape from "@/assets/images/why-node-globe.png";

const WhyNode: React.FC = () => {
  const components = [
    {
      title: "L1 Native Staking",
      subtitle:
        "Earn rewards while contributing to the security and performance.",
      src: starShape,
      size: 90,
    },
    {
      title: "Simple Token Deployment",
      subtitle:
        "Deploy and manage your tokens with ease, using intuitive tools.",
      src: globeShape,
      size: 70,
    },
    {
      title: "Atomic Swaps",
      subtitle:
        "Fast, secure token swaps, empowering users with flexibility and speed.",
      src: starShape,
      size: 90,
    },
  ];
  return (
    <div className="flex w-full flex-col md:flex-row px-16 items-stretch py-20 gap-10">
      {components.map((componentInfo) => {
        return (
          <WhyNodeComponent
            title={componentInfo.title}
            subtitle={componentInfo.subtitle}
            src={componentInfo.src}
            size={componentInfo.size}
          />
        );
      })}
    </div>
  );
};

export default WhyNode;
